export const actionTypes = {
    LOGOUT: 'LOGOUT',
}